module.exports = __webpack_public_path__ + "img/banner3_1_en.6cdc99d1.png";